import React from 'react';
import { Card, Row, Col, Input, Button,
	message, Spin, Form, DatePicker, Divider, Typography, Tag, Alert, Tabs,
} from 'antd';
import {
	SearchOutlined, CopyOutlined, PrinterOutlined,
	CalendarOutlined, FileTextOutlined, FileDoneOutlined,
	FileProtectOutlined, ReloadOutlined, InfoCircleOutlined,
} from '@ant-design/icons';

import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, ajaxHandler, setConfig } from '../../store/actions';
import Config from '../../Config';
import { Helmet } from 'react-helmet';
import ErrorAlertModal from '../../components/ErrorAlertModal';
import '../../assets/laporan.css';

const { Text } = Typography;

const configClass = {
	title: 'STS Harian',
	apiUrl: {
		data:             'laporan/api/sts_harian/',
		warna_plat:       'master/api/plat',
		jenis_kendaraan:  'master/api/jenis/kendaraan/',
		payment:          'master/api/payment/',
		upt:              'pegawai/api/upt/',
		kabupaten:        'master/api/kabupaten/',
	},
	pageUrl: {
		cetak:       '/laporan/sts-harian',
		cetak_opsen: '/laporan/sts-opsen-harian',
		cetak_sp3:   '/laporan/sts-sp3-harian',
		cetak_edc:        '/laporan/sts-edc-harian',
		cetak_opsen_edc:  '/laporan/sts-opsen-edc-harian',
	},
	breadCrumb: ['Laporan', 'STS Harian'],
};

const config = new Config();

class StsHarian extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			loading:   false,
			data:      null,
			err:       false,
			errMsg:    '',
			filter:    '',
			tgl_dari:  '',
			activeTab: 'opsen',
		};
	}

	UNSAFE_componentWillMount() { this.props.initHandler(); }

	handleSubmit = (values) => {
		const parts = [];
		for (const key in values) {
			if (values[key] !== undefined && values[key] !== null && values[key] !== '') {
				parts.push(`${key}=${values[key]}`);
			}
		}
		const filter = parts.length ? '?' + parts.join('&') : '';
		this.setState({ filter });
		this.getData(filter);
	};

	handlePrint = (sectionClass) => {
		const section = document.querySelector(`.${sectionClass}`);
		if (!section) return;
		const parent  = section.parentNode;
		const nextSib = section.nextSibling;
		document.body.appendChild(section);
		const siblings = Array.from(document.body.children).filter(el => el !== section);
		siblings.forEach(el => { el.style.display = 'none'; });
		window.print();
		siblings.forEach(el => { el.style.display = ''; });
		if (nextSib) parent.insertBefore(section, nextSib);
		else parent.appendChild(section);
	}

	async getData(filter) {
		message.loading({ content: 'Memuat laporan STS...', duration: 0, key: 'toast' });
		this.setState({ loading: true, err: false, data: null });

		this.props.ajaxViewHandler('get', configClass.apiUrl.data + filter)
			.then(() => {
				const data = this.props.responseMsg;
				if (this.props.isSuccess) {
					message.destroy();
					this.setState({ loading: false, data, err: false });
				} else {
					this.setState({ loading: false, data: null, err: true, errMsg: this.props.responseMsg });
					message.error({ content: 'Gagal memuat laporan', duration: 2, key: 'toast' });
				}
			})
			.catch(() => {
				this.setState({ loading: false, data: null, err: true, errMsg: 'Kesalahan koneksi' });
				message.error({ content: 'Gagal request data', duration: 2, key: 'toast' });
			});
	}

	render() {
		const { loading, data, err, errMsg, filter, tgl_dari, activeTab } = this.state;
		const hasData = data !== null && Array.isArray(data) && data.length > 0;

		const TAB_CONFIG = [
			{ key: 'opsen',     label: 'Opsen',     section: 'sts-section-opsen',     color: '#fa8c16', icon: <FileDoneOutlined /> },
			{ key: 'sts',       label: 'STS',       section: 'sts-section-sts',       color: '#0f2847', icon: <FileTextOutlined /> },
			{ key: 'opsen-edc', label: 'Opsen EDC', section: 'sts-section-opsen-edc', color: '#722ed1', icon: <FileDoneOutlined /> },
			{ key: 'edc',       label: 'EDC',       section: 'sts-section-edc',       color: '#722ed1', icon: <FileTextOutlined /> },
			{ key: 'spk',       label: 'SPK',       section: 'sts-section-sp3',       color: '#52c41a', icon: <FileProtectOutlined /> },
		];
		const activeTabConfig = TAB_CONFIG.find(t => t.key === activeTab);

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.sts-harian-wrap .ant-picker,
						.sts-harian-wrap .ant-picker input {
							text-transform: none !important;
						}
					`}</style>
				</Helmet>


				<div className="sts-harian-wrap">

					{/* ── Header Card ── */}
					<Card
						bodyStyle={{ padding: 0 }}
						style={{
							borderRadius: 14,
							overflow: 'hidden',
							boxShadow: '0 4px 24px rgba(0,0,0,0.10)',
							border: 'none',
							marginBottom: 20,
						}}
					>
						{/* Gradient header */}
						<div style={{
							background: 'linear-gradient(135deg, #0f2847 0%, #1e4d8a 60%, #0a3d6b 100%)',
							padding: '22px 28px',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'space-between',
							flexWrap: 'wrap',
							gap: 12,
						}}>
							<div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
								<div style={{
									width: 52, height: 52,
									borderRadius: 12,
									background: 'rgba(255,255,255,0.15)',
									backdropFilter: 'blur(4px)',
									display: 'flex', alignItems: 'center', justifyContent: 'center',
									fontSize: 24, color: '#fff',
									border: '1px solid rgba(255,255,255,0.25)',
								}}>
									<CopyOutlined />
								</div>
								<div>
									<div style={{ color: '#fff', fontWeight: 700, fontSize: 18, letterSpacing: 0.3 }}>
										{configClass.title}
									</div>
									<div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 12, marginTop: 2 }}>
										Surat Tanda Setoran — Laporan Harian
									</div>
								</div>
							</div>

							{/* Status badge */}
							<div>
								{loading && (
									<Tag icon={<Spin size="small" style={{ marginRight: 6 }} />}
										style={{ borderRadius: 20, padding: '4px 14px', background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', color: '#fff', fontSize: 12 }}>
										Memuat...
									</Tag>
								)}
								{hasData && !loading && (
									<Tag icon={<FileDoneOutlined style={{ marginRight: 4 }} />}
										style={{ borderRadius: 20, padding: '4px 14px', background: 'rgba(82,196,26,0.2)', border: '1px solid rgba(82,196,26,0.5)', color: '#95de64', fontSize: 12 }}>
										Data Siap
									</Tag>
								)}
								{!hasData && !loading && data === null && (
									<Tag icon={<InfoCircleOutlined style={{ marginRight: 4 }} />}
										style={{ borderRadius: 20, padding: '4px 14px', background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.25)', color: 'rgba(255,255,255,0.7)', fontSize: 12 }}>
										Pilih tanggal untuk mulai
									</Tag>
								)}
							</div>
						</div>

						{/* ── Filter panel ── */}
						<div style={{ padding: '20px 28px', background: '#fff' }}>
							<Form
								layout="vertical"
								name="fdata"
								onFinish={this.handleSubmit}
								ref={this.formRef}
							>
								<Row gutter={[16, 0]} align="bottom">

									{/* Tanggal */}
									<Col xs={24} sm={10} md={8} lg={6}>
										<Form.Item
											label={
												<span style={{ fontWeight: 600, color: '#444', fontSize: 13 }}>
													<CalendarOutlined style={{ marginRight: 6, color: '#1e4d8a' }} />
													Pilih Tanggal
												</span>
											}
											name="mulai_dari_picker"
										>
											<DatePicker
												placeholder="dd-mm-yyyy"
												format="DD-MM-YYYY"
												size="large"
												style={{ width: '100%', borderRadius: 8 }}
												onChange={(date, dateString) => {
													this.formRef.current.setFieldsValue({ mulai_dari: dateString });
													this.setState({ tgl_dari: dateString });
												}}
											/>
										</Form.Item>
										<Form.Item name="mulai_dari" style={{ display: 'none' }}>
											<Input type="hidden" />
										</Form.Item>
									</Col>

									{/* Tombol aksi */}
									<Col xs={24} sm={14} md={16} lg={18}>
										<Form.Item label=" ">
											<div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>

												{/* Proses */}
												<Button
													type="primary"
													htmlType="submit"
													loading={loading}
													size="large"
													icon={<SearchOutlined />}
													style={{
														borderRadius: 8,
														fontWeight: 600,
														background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
														border: 'none',
														minWidth: 110,
													}}
												>
													Proses
												</Button>

												{/* Reset */}
												{hasData && (
													<Button
														size="large"
														icon={<ReloadOutlined />}
														style={{ borderRadius: 8 }}
														onClick={() => {
															this.formRef.current.resetFields();
															this.setState({ data: null, filter: '', tgl_dari: '' });
														}}
													>
														Reset
													</Button>
												)}

											</div>
										</Form.Item>
									</Col>
								</Row>
							</Form>

							{/* Tombol cetak — muncul setelah data ada, sesuai tab aktif */}
							{hasData && activeTabConfig && (
								<>
									<Divider style={{ margin: '4px 0 16px' }} />
									<div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
										<Text style={{ fontSize: 12, color: '#888', marginRight: 4 }}>Cetak :</Text>
										<Button
											size="large"
											icon={<PrinterOutlined />}
											style={{
												borderRadius: 8, fontWeight: 600,
												borderColor: activeTabConfig.color,
												color: activeTabConfig.color,
											}}
											onClick={() => this.handlePrint(activeTabConfig.section)}
										>
											{activeTabConfig.icon}
											<span style={{ marginLeft: 6 }}>{activeTabConfig.label}</span>
										</Button>
									</div>
								</>
							)}
						</div>
					</Card>

					{/* ── Error ── */}
					<ErrorAlertModal
						visible={!!err}
						title="Gagal memuat laporan"
						error={errMsg}
						onClose={() => this.setState({ err: false })}
					/>

					{/* ── Loading state ── */}
					{loading && (
						<Card
							style={{ borderRadius: 14, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', border: 'none' }}
							bodyStyle={{ padding: '48px 0' }}
						>
							<div style={{ textAlign: 'center' }}>
								<Spin size="large" />
								<div style={{ marginTop: 16, color: '#888', fontSize: 14 }}>
									Memproses laporan STS Harian...
								</div>
							</div>
						</Card>
					)}

					{/* ── Empty state ── */}
					{!loading && data === null && !err && (
						<Card
							style={{ borderRadius: 14, boxShadow: '0 2px 12px rgba(0,0,0,0.07)', border: 'none' }}
							bodyStyle={{ padding: '56px 0' }}
						>
							<div style={{ textAlign: 'center' }}>
								<div style={{
									width: 72, height: 72,
									borderRadius: '50%',
									background: 'linear-gradient(135deg, #e6f0ff, #c8dbff)',
									display: 'flex', alignItems: 'center', justifyContent: 'center',
									margin: '0 auto 16px',
									fontSize: 32, color: '#1e4d8a',
								}}>
									<CopyOutlined />
								</div>
								<Text strong style={{ fontSize: 15, color: '#333' }}>Belum Ada Data</Text>
								<div style={{ color: '#aaa', fontSize: 13, marginTop: 6 }}>
									Pilih tanggal lalu klik <strong>Proses</strong> untuk menampilkan laporan STS Harian
								</div>
							</div>
						</Card>
					)}

					{/* ── Preview dokumen ── */}
					{hasData && !loading && (
						<Card
							style={{
								borderRadius: 14,
								boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
								border: 'none',
								overflow: 'auto',
							}}
							bodyStyle={{ padding: 0 }}
						>
							{/* Strip header preview */}
							<div style={{
								padding: '12px 20px',
								background: 'linear-gradient(135deg, #0f284710, #1e4d8a08)',
								borderBottom: '2px solid #e8edf5',
								display: 'flex', alignItems: 'center', gap: 10,
							}}>
								<FileTextOutlined style={{ color: '#1e4d8a', fontSize: 15 }} />
								<Text strong style={{ fontSize: 13, color: '#0f2847' }}>
									Preview Dokumen — {tgl_dari || 'Semua Tanggal'}
								</Text>
								<Tag color="blue" style={{ borderRadius: 20, fontSize: 11, marginLeft: 'auto' }}>
									{data.length} Kabupaten
								</Tag>
							</div>

							<Tabs
								activeKey={activeTab}
								onChange={(key) => this.setState({ activeTab: key })}
								type="card"
								style={{ padding: '0 16px 16px' }}
								tabBarStyle={{ marginBottom: 0, paddingTop: 12 }}
								items={TAB_CONFIG.map(tab => ({
									key: tab.key,
									label: (
										<span style={{ fontWeight: 600, color: activeTab === tab.key ? tab.color : undefined }}>
											{React.cloneElement(tab.icon, { style: { marginRight: 5 } })}
											{tab.label}
										</span>
									),
								}))}
							/>

							<div style={{ padding: '20px 24px' }}>

								{/* STS OPSEN */}
								<div className="sts-section-opsen" style={{ display: activeTab === 'opsen' ? 'block' : 'none' }}>
								{data.map((item, idx) => (
									<div key={'opsen-' + idx} className="kertas-laporan pagebreak">
										<div className="judul-laporan-sts" style={{ borderBottom: 'double 5px #000000' }}>
											<img src={config.get_site_info().logo_bw} alt="logo" />
											PEMERINTAH PROVINSI KALIMANTAN TENGAH<br />
											SURAT TANDA SETORAN (STS) OPSEN PAJAK
										</div>
										<br />
										<table className="laporan-table" cellPadding="5" style={{ fontSize: '12px', border: '1px solid #000000' }}>
											{item.opsen.map((subItem, subIdx) => (
												<React.Fragment key={subIdx}>
													<tr style={{ border: '1px solid #000000', fontWeight: 'bold' }}>
														<td width={300}>{subItem.kabupaten}</td>
														<td className="teks-kanan">
															| {subItem.no_rekening}--({subItem.nama_penerima}) |
														</td>
													</tr>
													<tr>
														<td style={{ border: '1px solid #000000' }}>- OPSEN PKB</td>
														<td className="teks-kanan" style={{ border: '1px solid #000000' }}>
															{(subItem.pokok.pkb + subItem.denda.pkb).toLocaleString('id')}
														</td>
													</tr>
													{subItem.pokok.bbnkb > 0 && (
														<tr>
															<td style={{ border: '1px solid #000000' }}>- OPSEN BBNKB</td>
															<td className="teks-kanan" style={{ border: '1px solid #000000' }}>
																{(subItem.pokok.bbnkb + subItem.denda.bbnkb).toLocaleString('id')}
															</td>
														</tr>
													)}
												</React.Fragment>
											))}
											<tr>
												<td className="teks-kanan" style={{ borderTop: '1px solid #000000', borderRight: '1px solid #000000', borderLeft: '1px solid #000000', fontWeight: 'bold' }}>JUMLAH</td>
												<td className="teks-kanan" style={{ borderTop: '1px solid #000000', borderRight: '1px solid #000000', borderLeft: '1px solid #000000', fontWeight: 'bold' }}>
													{item.total_opsen.toLocaleString('id')}
												</td>
											</tr>
										</table>
										<br />
										{item.ttd !== undefined && (
											<Row justify="space-between" style={{ marginTop: 10 }}>
												<Col span={8} className="teks-tengah">
													{item.ttd.ttd.kiri.jabatan}<br />
													<div style={{ marginTop: 50 }}>
														<u>{item.ttd.ttd.kiri.nama}</u><br />
														NIP : {item.ttd.ttd.kiri.nip}
													</div>
												</Col>
												<Col span={8} className="teks-tengah">
													{item.ttd.ttd.kanan.jabatan}<br />
													<div style={{ marginTop: 50 }}>
														<u>{item.ttd.ttd.kanan.nama}</u><br />
														NIP : {item.ttd.ttd.kanan.nip}
													</div>
												</Col>
												<Col span={8} className="teks-tengah">
													{item.kabupaten_asal},<br />
													{'TGL ' + tgl_dari}
												</Col>
											</Row>
										)}
									</div>
								))}
								</div>{/* end sts-section-opsen */}

								{/* STS MURNI */}
								<div className="sts-section-sts" style={{ display: activeTab === 'sts' ? 'block' : 'none' }}>
								{data.map((item, idx) => (
									<div key={'murni-' + idx} className="kertas-laporan pagebreak">
										<div className="judul-laporan-sts" style={{ borderBottom: 'double 5px #000000' }}>
											<img src={config.get_site_info().logo_bw} alt="logo" />
											PEMERINTAH PROVINSI KALIMANTAN TENGAH<br />
											SURAT TANDA SETORAN<br />(STS)
										</div>
										<Row style={{fontSize: '14px',}}>
											<Col span={13} className="setoran-ke">Setoran yang ke : {item.nomor}</Col>
											<Col span={11} className="kepada">
												<span className="samsat">{item.kabupaten}</span><br />
												Kas Daerah Provinsi Kalimantan Tengah<br />
												di. -<br />PALANGKARAYA
											</Col>
										</Row>
										<div className="deskripsi" style={{ fontSize: '14px' }}>
											Harap Menerima Uang Sebesar : {item.jumlah.toLocaleString('ID')}<br />
											{'# ' + config.pembilang(item.jumlah) + ' #'}<br />
											Yaitu Penerima : {item.akun_bank}<br />
											Dengan Rincian Sebagai Berikut :
										</div>
										<table className="laporan-table" cellPadding="5" style={{ fontSize: '16px', border: '1px solid #000000' }}>
											<tr style={{ borderBottom: '1px solid #000000' }}>
												<th style={{ borderRight: '1px solid #000000' }}>KODE REKENING</th>
												<th style={{ borderRight: '1px solid #000000' }}>URAIAN JENIS PENERIMAAN</th>
												<th style={{ borderRight: '1px solid #000000', width: '50px' }}>JUMLAH KB</th>
												<th style={{ borderRight: '1px solid #000000' }}>JUMLAH (Rp.)</th>
											</tr>
											{item.data.map((subItem, subIdx) => (
												<tr key={subIdx}>
													<td style={{ borderRight: '1px solid #000000' }}>{subItem.nomor_rekening}</td>
													<td style={{ borderRight: '1px solid #000000' }}>{subItem.nama}</td>
													<td style={{ borderRight: '1px solid #000000' }} className="teks-kanan">{subItem.jumlah}</td>
													<td style={{ borderRight: '1px solid #000000' }} className="teks-kanan">{subItem.total.toLocaleString('id')}</td>
												</tr>
											))}
											<tr>
												<td colSpan={2} style={{ border: '1px solid #000000', fontWeight: 'bold' }}>JUMLAH SELURUH</td>
												<td style={{ border: '1px solid #000000', fontWeight: 'bold' }} className="teks-kanan">{item.unit.toLocaleString('id')}</td>
												<td style={{ border: '1px solid #000000', fontWeight: 'bold' }} className="teks-kanan">{item.jumlah.toLocaleString('id')}</td>
											</tr>
										</table>
										<br />
										{item.ttd !== undefined && (
											<Row justify="space-between" style={{ marginTop: 10 }}>
												<Col span={8} className="teks-tengah">
													{item.ttd.ttd.kiri.jabatan}<br />
													<div style={{ marginTop: 50 }}>
														<u>{item.ttd.ttd.kiri.nama}</u><br />
														NIP : {item.ttd.ttd.kiri.nip}
													</div>
												</Col>
												<Col span={8} className="teks-tengah">
													{item.ttd.ttd.kanan.jabatan}<br />
													<div style={{ marginTop: 50 }}>
														<u>{item.ttd.ttd.kanan.nama}</u><br />
														NIP : {item.ttd.ttd.kanan.nip}
													</div>
												</Col>
												<Col span={8} className="teks-tengah">
													{item.kabupaten_asal},<br />
													{'TGL ' + tgl_dari}
												</Col>
											</Row>
										)}
									</div>
								))}
								</div>{/* end sts-section-sts */}

								{/* STS OPSEN EDC */}
								<div className="sts-section-opsen-edc" style={{ display: activeTab === 'opsen-edc' ? 'block' : 'none' }}>
								{data.map((item, idx) => (
									<div key={'opsen-edc-' + idx} className="kertas-laporan pagebreak">
										<div className="judul-laporan-sts" style={{ borderBottom: 'double 5px #000000' }}>
											<img src={config.get_site_info().logo_bw} alt="logo" />
											PEMERINTAH PROVINSI KALIMANTAN TENGAH<br />
											SURAT TANDA SETORAN (STS) OPSEN PAJAK EDC
										</div>
										<br />
										{(!item.opsen_edc || item.opsen_edc.length === 0) ? (
											<div style={{ padding: '12px 0', color: '#888', fontStyle: 'italic', fontSize: 13 }}>
												Tidak ada transaksi Opsen EDC pada tanggal ini.
											</div>
										) : (
											<table className="laporan-table" cellPadding="5" style={{ fontSize: '14px', border: '1px solid #000000' }}>
												{item.opsen_edc.map((subItem, subIdx) => (
													<React.Fragment key={subIdx}>
														<tr style={{ border: '1px solid #000000', fontWeight: 'bold' }}>
															<td width={300}>{subItem.kabupaten}</td>
															<td className="teks-kanan">
																| {subItem.no_rekening}--({subItem.nama_penerima}) |
															</td>
														</tr>
														<tr>
															<td style={{ border: '1px solid #000000' }}>- OPSEN PKB</td>
															<td className="teks-kanan" style={{ border: '1px solid #000000' }}>
																{(subItem.pokok.pkb + subItem.denda.pkb).toLocaleString('id')}
															</td>
														</tr>
														{subItem.pokok.bbnkb > 0 && (
															<tr>
																<td style={{ border: '1px solid #000000' }}>- OPSEN BBNKB</td>
																<td className="teks-kanan" style={{ border: '1px solid #000000' }}>
																	{(subItem.pokok.bbnkb + subItem.denda.bbnkb).toLocaleString('id')}
																</td>
															</tr>
														)}
													</React.Fragment>
												))}
												<tr>
													<td className="teks-kanan" style={{ borderTop: '1px solid #000000', borderRight: '1px solid #000000', borderLeft: '1px solid #000000', fontWeight: 'bold' }}>JUMLAH</td>
													<td className="teks-kanan" style={{ borderTop: '1px solid #000000', borderRight: '1px solid #000000', borderLeft: '1px solid #000000', fontWeight: 'bold' }}>
														{(item.total_opsen_edc || 0).toLocaleString('id')}
													</td>
												</tr>
											</table>
										)}
										<br />
										{item.ttd !== undefined && (
											<Row justify="space-between" style={{ marginTop: 10 }}>
												<Col span={8} className="teks-tengah">
													{item.ttd.ttd.kiri.jabatan}<br />
													<div style={{ marginTop: 50 }}>
														<u>{item.ttd.ttd.kiri.nama}</u><br />
														NIP : {item.ttd.ttd.kiri.nip}
													</div>
												</Col>
												<Col span={8} className="teks-tengah">
													{item.ttd.ttd.kanan.jabatan}<br />
													<div style={{ marginTop: 50 }}>
														<u>{item.ttd.ttd.kanan.nama}</u><br />
														NIP : {item.ttd.ttd.kanan.nip}
													</div>
												</Col>
												<Col span={8} className="teks-tengah">
													{item.kabupaten_asal},<br />
													{'TGL ' + tgl_dari}
												</Col>
											</Row>
										)}
									</div>
								))}
								</div>{/* end sts-section-opsen-edc */}

								{/* STS EDC */}
								<div className="sts-section-edc" style={{ display: activeTab === 'edc' ? 'block' : 'none' }}>
								{data.map((item, idx) => (
									<div key={'edc-' + idx} className="kertas-laporan pagebreak">
										<div className="judul-laporan-sts" style={{ borderBottom: 'double 5px #000000' }}>
											<img src={config.get_site_info().logo_bw} alt="logo" />
											PEMERINTAH PROVINSI KALIMANTAN TENGAH<br />
											SURAT TANDA SETORAN<br />(STS) EDC
										</div>
										<Row style={{fontSize: '14px',}}>
											<Col span={13} className="setoran-ke">Setoran yang ke : {item.nomor_edc}</Col>
											<Col span={11} className="kepada">
												<span className="samsat">{item.kabupaten}</span><br />
												Kas Daerah Provinsi Kalimantan Tengah<br />
												di. -<br />PALANGKARAYA
											</Col>
										</Row>
										<div className="deskripsi" style={{ fontSize: '14px' }}>
											Harap Menerima Uang Sebesar : {(item.jumlah_edc || 0).toLocaleString('ID')}<br />
											{'# ' + config.pembilang(item.jumlah_edc || 0) + ' #'}<br />
											Yaitu Penerima : {item.akun_bank}<br />
											Dengan Rincian Sebagai Berikut :
										</div>
										{(!item.data_edc || item.data_edc.length === 0) ? (
											<div style={{ padding: '12px 0', color: '#888', fontStyle: 'italic', fontSize: 13 }}>
												Tidak ada transaksi EDC pada tanggal ini.
											</div>
										) : (
											<table className="laporan-table" cellPadding="5" style={{ fontSize: '16px', border: '1px solid #000000' }}>
												<tr style={{ borderBottom: '1px solid #000000' }}>
													<th style={{ borderRight: '1px solid #000000' }}>KODE REKENING</th>
													<th style={{ borderRight: '1px solid #000000' }}>URAIAN JENIS PENERIMAAN</th>
													<th style={{ borderRight: '1px solid #000000', width: '50px' }}>JUMLAH KB</th>
													<th style={{ borderRight: '1px solid #000000' }}>JUMLAH (Rp.)</th>
												</tr>
												{item.data_edc.map((subItem, subIdx) => (
													<tr key={subIdx}>
														<td style={{ borderRight: '1px solid #000000' }}>{subItem.nomor_rekening}</td>
														<td style={{ borderRight: '1px solid #000000' }}>{subItem.nama}</td>
														<td style={{ borderRight: '1px solid #000000' }} className="teks-kanan">{subItem.jumlah}</td>
														<td style={{ borderRight: '1px solid #000000' }} className="teks-kanan">{subItem.total.toLocaleString('id')}</td>
													</tr>
												))}
												<tr>
													<td colSpan={2} style={{ border: '1px solid #000000', fontWeight: 'bold' }}>JUMLAH SELURUH</td>
													<td style={{ border: '1px solid #000000', fontWeight: 'bold' }} className="teks-kanan">{(item.unit_edc || 0).toLocaleString('id')}</td>
													<td style={{ border: '1px solid #000000', fontWeight: 'bold' }} className="teks-kanan">{(item.jumlah_edc || 0).toLocaleString('id')}</td>
												</tr>
											</table>
										)}
										<br />
										{item.ttd !== undefined && (
											<Row justify="space-between" style={{ marginTop: 10 }}>
												<Col span={8} className="teks-tengah">
													{item.ttd.ttd.kiri.jabatan}<br />
													<div style={{ marginTop: 50 }}>
														<u>{item.ttd.ttd.kiri.nama}</u><br />
														NIP : {item.ttd.ttd.kiri.nip}
													</div>
												</Col>
												<Col span={8} className="teks-tengah">
													{item.ttd.ttd.kanan.jabatan}<br />
													<div style={{ marginTop: 50 }}>
														<u>{item.ttd.ttd.kanan.nama}</u><br />
														NIP : {item.ttd.ttd.kanan.nip}
													</div>
												</Col>
												<Col span={8} className="teks-tengah">
													{item.kabupaten_asal},<br />
													{'TGL ' + tgl_dari}
												</Col>
											</Row>
										)}
									</div>
								))}
								</div>{/* end sts-section-edc */}

								{/* STS SPK */}
								<div className="sts-section-sp3" style={{ display: activeTab === 'spk' ? 'block' : 'none' }}>
								{data.map((item, idx) => (
									<div key={'sp3-' + idx} className="kertas-laporan pagebreak">
										<div className="judul-laporan-sts" style={{ borderBottom: 'double 5px #000000' }}>
											<img src={config.get_site_info().logo_bw} alt="logo" />
											PEMERINTAH PROVINSI KALIMANTAN TENGAH<br />
											SURAT TANDA SETORAN<br />(STS)
										</div>
										<Row style={{fontSize: '14px',}}>
											<Col span={13} className="setoran-ke">Setoran yang ke : {item.nomor_sp3}</Col>
											<Col span={11} className="kepada">
												<span className="samsat">{item.kabupaten}</span><br />
												Kas Daerah Provinsi Kalimantan Tengah<br />
												di. -<br />PALANGKARAYA
											</Col>
										</Row>
										<div className="deskripsi" style={{ fontSize: '14px' }}>
											Harap Menerima Uang Sebesar : {item.total_sp3.toLocaleString('ID')}<br />
											{'# ' + config.pembilang(item.total_sp3) + ' #'}<br />
											Yaitu Penerima : {item.akun_bank}<br />
											Dengan Rincian Sebagai Berikut :
										</div>
										<table className="laporan-table" cellPadding="5" style={{ fontSize: '16px', border: '1px solid #000000' }}>
											<tr style={{ borderBottom: '1px solid #000000' }}>
												<th style={{ borderRight: '1px solid #000000' }}>KODE REKENING</th>
												<th style={{ borderRight: '1px solid #000000' }}>URAIAN JENIS PENERIMAAN</th>
												<th style={{ borderRight: '1px solid #000000', width: '50px' }}>JUMLAH KB</th>
												<th style={{ borderRight: '1px solid #000000' }}>JUMLAH (Rp.)</th>
											</tr>
											{item.sp3.map((subItem, subIdx) => (
												<tr key={subIdx}>
													<td style={{ borderRight: '1px solid #000000' }}>{subItem.nomor_rekening}</td>
													<td style={{ borderRight: '1px solid #000000' }}>{subItem.nama}</td>
													<td style={{ borderRight: '1px solid #000000' }} className="teks-kanan">{subItem.jumlah}</td>
													<td style={{ borderRight: '1px solid #000000' }} className="teks-kanan">{subItem.total.toLocaleString('id')}</td>
												</tr>
											))}
											<tr>
												<td colSpan={2} style={{ border: '1px solid #000000', fontWeight: 'bold' }}>JUMLAH SELURUH</td>
												<td style={{ border: '1px solid #000000', fontWeight: 'bold' }} className="teks-kanan">{item.unit_sp3.toLocaleString('id')}</td>
												<td style={{ border: '1px solid #000000', fontWeight: 'bold' }} className="teks-kanan">{item.total_sp3.toLocaleString('id')}</td>
											</tr>
										</table>
										<br />
										{item.ttd !== undefined && (
											<Row justify="space-between" style={{ marginTop: 10 }}>
												<Col span={8} className="teks-tengah">
													{item.ttd.ttd.kiri.jabatan}<br />
													<div style={{ marginTop: 50 }}>
														<u>{item.ttd.ttd.kiri.nama}</u><br />
														NIP : {item.ttd.ttd.kiri.nip}
													</div>
												</Col>
												<Col span={8} className="teks-tengah">
													{item.ttd.ttd.kanan.jabatan}<br />
													<div style={{ marginTop: 50 }}>
														<u>{item.ttd.ttd.kanan.nama}</u><br />
														NIP : {item.ttd.ttd.kanan.nip}
													</div>
												</Col>
												<Col span={8} className="teks-tengah">
													{item.kabupaten_asal},<br />
													{'TGL ' + tgl_dari}
												</Col>
											</Row>
										)}
									</div>
								))}
								</div>{/* end sts-section-sp3 */}

							</div>
						</Card>
					)}

				</div>
			</div>
		);
	}
}

const mapStateToProps = state => state.configReducers;

export default connect(
	mapStateToProps,
	{ initHandler, setConfig, ajaxViewHandler, ajaxHandler }
)(StsHarian);
